export default "__VITE_ASSET__c0ywZz06__"